import actions from './actions'
export default {
  actions
};


// WEBPACK FOOTER //
// ./src/store/agreement/index.js